import React from 'react';
import { MASS_ACTION } from 'constants/config';

const MenuItem = ({ onViewChange, view, title }) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
  <div className="BulkAction-menuItem" onClick={() => onViewChange(view)}>
    {title}
  </div>
);

const menuItems = () => [
  {
    view: MASS_ACTION.MASS_TAGGING,
    title: t('mass_actions.mass_tagging.title'),
  },
  {
    view: MASS_ACTION.MASS_OWNERSHIP,
    title: t('mass_actions.mass_ownership.title'),
  },
  {
    view: MASS_ACTION.MASS_LEARN,
    title: t('mass_actions.mass_learn.title'),
  },
  {
    view: MASS_ACTION.ARCHIVE,
    title: t('actions.archive'),
  },
];

const BulkActionMenu = props => (
  <div>
    {menuItems(props).map(menuItem => (
      <MenuItem
        key={menuItem.view}
        view={menuItem.view}
        title={menuItem.title}
        onViewChange={props.onViewChange}
      />
    ))}
  </div>
);

export default BulkActionMenu;
